export const initCopyUrl = () => {
  const shareBtn = document.getElementById('share-button');
  if (!shareBtn) return;
  const share = document.getElementById('share');

  shareBtn.addEventListener('click', () => {
    shareBtn.setAttribute(
      'aria-expanded', shareBtn.getAttribute('aria-expanded') === 'false' ? 'true' : 'false',
    );
    share.classList.toggle('share--expanded');
  });

  const copyBtn = document.getElementById('copy-url');
  if (!copyBtn) return;
  copyBtn.addEventListener('click', () => {
    const inputc = document.body.appendChild(document.createElement('input'));
    inputc.value = window.location.href;
    inputc.focus();
    inputc.select();
    document.execCommand('copy');
    inputc.parentNode.removeChild(inputc);

    copyBtn.classList.add('copied');

    const temp = setInterval(() => {
      copyBtn.classList.remove('copied');
      clearInterval(temp);
    }, 1200);
  });
};

export default 'initCopyUrl';
